/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".folded:not(.unfolded)   [_nghost-%COMP%]   .nav-link[_ngcontent-%COMP%] > .nav-link-badge[_ngcontent-%COMP%], .folded:not(.unfolded)   [_nghost-%COMP%]   .nav-link[_ngcontent-%COMP%] > .nav-link-title[_ngcontent-%COMP%]{opacity:0;-webkit-transition:opacity .2s;transition:opacity .2s ease}"];
export { styles as styles };
